export interface ISortEvent {
    column: string[];
    isDescending: boolean;
}
